import { Reducer } from 'redux';

import { IErrorActionData } from '../../../models/Error';
import { GetDisplayInventoryListUrlActionTypes, GetDisplayInventoryListUrlActions } from '../actions/GetDisplayInventoryListUrl';

export interface IDisplayInventoryListUrlState {
  data: string;
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initialDisplayInventorySummaryState = {
  data: '',
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IDisplayInventoryListUrlState;

const GetDisplayInventoryListUrlReducer: Reducer<IDisplayInventoryListUrlState, GetDisplayInventoryListUrlActions> = (
  state = initialDisplayInventorySummaryState,
  action: GetDisplayInventoryListUrlActions,
): IDisplayInventoryListUrlState => {
  switch (action.type) {
    case GetDisplayInventoryListUrlActionTypes.GET_DISPLAY_INVENTORY_LIST_URL:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case GetDisplayInventoryListUrlActionTypes.GET_DISPLAY_INVENTORY_LIST_URL_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };
    }

    case GetDisplayInventoryListUrlActionTypes.GET_DISPLAY_INVENTORY_LIST_URL_FAILED:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case GetDisplayInventoryListUrlActionTypes.GET_DISPLAY_INVENTORY_LIST_URL_RESET:
      return initialDisplayInventorySummaryState;

    default:
      return state;
  }
};

export default GetDisplayInventoryListUrlReducer;
